<template>
  <div id="modalContactsClient" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Contatos do Cliente</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body">
          <div class="text-end mb-3">
            <button
              type="button"
              class="btn btn-primary"
              title="Importar contatos de projetos anteriores"
              @click="showImportContactsModal = true"
            >
              <i class="ph ph-plus me-2" />
              Importar contatos de projetos anteriores
            </button>
          </div>
          <div v-if="contacts.length > 0" class="table-responsive">
            <table class="table table-striped table-sm table-bordered fs-sm">
              <thead>
                <tr>
                  <th>Identificador</th>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Função</th>
                  <th>Observação</th>
                  <th class="text-center">Notif. Franquia</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contact in contacts" :key="contact.id">
                  <td>{{ contact.identificador }}</td>
                  <td>{{ contact.nome }}</td>
                  <td>{{ contact.email }}</td>
                  <td>{{ funcaoContatoLabel(contact.funcao) }}</td>
                  <td>{{ contact.observacao }}</td>
                  <td
                    v-html="optionsTranslate(contact.recebeNotificacaoFranquia)"
                    class="text-center"
                  />
                  <td
                    v-html="statusTranslate(contact.status)"
                    class="text-center"
                  />
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-icon"
                      title="Excluir"
                      @click="deleteContact(contact)"
                    >
                      <i class="ph ph-trash" />
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-warning btn-icon ms-2"
                      title="Editar"
                      @click="editContact(contact)"
                    >
                      <i class="ph ph-pencil" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <form @submit.prevent="save">
            <h6>{{ textModal }} Contato</h6>
            <div class="row g-3">
              <div class="col-lg-4 col-md-6">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.contact.nome.$errors.length }"
                  placeholder="Nome"
                  v-model="v$.contact.nome.$model"
                />
                <span
                  v-if="
                    v$.contact.nome.required.$invalid &&
                    v$.contact.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': v$.contact.email.$errors.length }"
                  placeholder="usuario@dominio.com.br"
                  v-model="v$.contact.email.$model"
                />
                <span
                  v-if="
                    v$.contact.email.required.$invalid &&
                    v$.contact.email.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.contact.email.email.$invalid &&
                    v$.contact.email.$errors.length
                  "
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-lg-4 col-md-6">
                <label class="form-label">
                  Função: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.contact.funcao.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in optionsFuncao"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-8 col-md-12">
                <label class="form-label">Observações:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Observações"
                  v-model="contact.observacao"
                />
              </div>
              <div class="col-lg-2 col-md-6">
                <label
                  class="form-label"
                  title="Recebe notificação de consumo de franquia"
                >
                  Notif. Franquia:
                </label>
                <select
                  class="form-select"
                  v-model="contact.recebeNotificacaoFranquia"
                >
                  <option
                    v-for="option in optionsRecebeNotificacao"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-lg-2 col-md-6">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.contact.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in optionsStatus"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="text-end">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :title="textModal"
                  :disabled="v$.$invalid || disableButton"
                >
                  <span v-if="disableButton">
                    <i class="ph ph-spinner spinner" />
                  </span>
                  <span v-else>{{ textModal }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer border-top-0 pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
    <ImportContactsClientModal
      v-if="showImportContactsModal"
      :clientId="clientId"
      :optionsFuncao="optionsFuncao"
      @closeModal="closeImportContactsModal"
    />
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import {
  funcaoContatoLabel,
  optionsTranslate,
  statusTranslate,
} from '@/utils/strings'
import { showModal } from '@/utils/modal'
import ImportContactsClientModal from '@/components/clients/ImportContactsClientModal.vue'

export default {
  name: 'ContactsClientModal',

  components: {
    ImportContactsClientModal,
  },

  props: {
    clientId: {
      type: String,
      required: true,
    },
  },

  emits: ['closeModal'],

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      contacts: [],
      contact: {
        clienteId: this.clientId,
        identificador: '',
        nome: '',
        email: '',
        funcao: '',
        observacao: '',
        recebeNotificacaoFranquia: 0,
        status: 1,
      },
      optionsFuncao: [
        { value: 1, text: 'Recebe NF' },
        { value: 2, text: 'Recebe Relatório' },
        { value: 3, text: 'Recebe NF/Relatório' },
        { value: 4, text: 'Usuário Chave' },
        { value: 5, text: 'Gestor de Contrato' },
      ],
      optionsRecebeNotificacao: [
        { value: 1, text: 'Sim' },
        { value: 0, text: 'Não' },
      ],
      optionsStatus: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      edit: false,
      disableButton: false,
      showImportContactsModal: false,
      funcaoContatoLabel,
      optionsTranslate,
      statusTranslate,
    }
  },

  computed: {
    textModal() {
      return this.edit ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getContactsClient() {
      try {
        this.contacts = await this.$store.dispatch(
          'getContactsClient',
          this.clientId,
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.edit) {
            response = await this.$store.dispatch('updateContactClient', {
              clienteId: this.clientId,
              contatoId: this.contact.id,
              contact: this.contact,
            })
          } else {
            response = await this.$store.dispatch('createContactClient', {
              clienteId: this.clientId,
              contact: this.contact,
            })
          }

          this.disableButton = false
          this.$root.$refs.notification.success(response.message)

          this.clearForm()
          this.getContactsClient()
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    editContact(contact) {
      this.edit = true
      this.contact = { ...contact }
    },

    async deleteContact(contact) {
      try {
        const response = await this.$store.dispatch('deleteContactClient', {
          clienteId: this.clientId,
          contatoId: contact.id,
        })
        this.$root.$refs.notification.success(response.message)
        this.getContactsClient()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeImportContactsModal(imported) {
      this.showImportContactsModal = false
      if (imported) {
        this.getContactsClient()
      }
    },

    clearForm() {
      this.edit = false
      this.contact = {
        clienteId: this.clientId,
        identificador: '',
        nome: '',
        email: '',
        funcao: '',
        observacao: '',
        recebeNotificacaoFranquia: 0,
        status: 1,
      }
      this.v$.$reset()
    },
  },

  validations() {
    return {
      contact: {
        nome: {
          required,
        },
        email: {
          required,
          email,
        },
        funcao: {
          required,
        },
        status: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getContactsClient()
    showModal('modalContactsClient')
  },
}
</script>
